function anonymizeEmail(email: string): string {
  const [localPart, domain] = email.split("@");
  if (localPart.length > 1) {
    const maskedLocalPart =
      localPart[0] +
      "*".repeat(localPart.length - 2) +
      localPart[localPart.length - 1];

    return `${maskedLocalPart}@${domain}`;
  } else {
    return `${localPart}@${domain}`;
  }
}

export default anonymizeEmail;
